"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var uniqueId = require("lodash.uniqueid");

var facialHair_1 = require("./facialHair");

var Eyepatch =
/** @class */
function (_super) {
  __extends(Eyepatch, _super);

  function Eyepatch() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.mask1 = uniqueId('react-mask-');
    _this.path1 = uniqueId('react-path-');
    return _this;
  }

  Eyepatch.prototype.render = function () {
    var _a = this,
        mask1 = _a.mask1,
        path1 = _a.path1;

    return React.createElement("g", {
      id: 'Top',
      strokeWidth: '1',
      fillRule: 'evenodd'
    }, React.createElement("defs", null, React.createElement("rect", {
      id: path1,
      x: '0',
      y: '0',
      width: '264',
      height: '280'
    })), React.createElement("mask", {
      id: mask1,
      fill: 'white'
    }, React.createElement("use", {
      xlinkHref: '#' + path1
    })), React.createElement("g", {
      id: 'Mask'
    }), React.createElement("g", {
      id: 'Top/Accesories/Eyepatch',
      mask: "url(#" + mask1 + ")"
    }, React.createElement("g", {
      transform: 'translate(-1.000000, 0.000000)'
    }, React.createElement(facialHair_1.default, null), React.createElement("path", {
      d: 'M160.395307,39.7810237 C157.318088,36.6927979 154.11865,43.6386608 152.623361,45.4281124 C149.013122,49.7486528 145.540256,54.182935 141.868413,58.4518947 C134.616309,66.8823544 127.439316,75.3743141 120.233991,83.8401528 C119.140279,85.1257012 119.27271,85.2649028 117.837048,85.3885641 C116.88598,85.4708947 115.563312,84.9802173 114.5737,84.9256608 C111.823607,84.774556 109.112057,85.2348141 106.435756,85.8227012 C101.091389,86.9961608 95.4264863,88.9291124 90.7890799,91.898306 C89.5718308,92.677306 88.7874545,93.5971608 87.4670933,93.841177 C86.3183659,94.0534512 84.794416,93.6295641 83.622299,93.5194592 C81.5412806,93.3237173 78.5378542,92.4726366 76.4953793,92.9137173 C73.9027538,93.4738302 72.9174244,96.6109915 75.5604528,98.0003624 C77.570314,99.0564431 81.5706,98.4761608 83.8235816,98.6447899 C86.3971,98.8372253 85.6120649,98.704306 85.2473843,101.164306 C84.7239177,104.69758 85.5985582,108.646475 87.0885766,111.878201 C90.5482655,119.383185 100.122861,127.335201 108.8551,126.603153 C116.142123,125.992451 122.526834,119.413274 125.519389,113.099935 C127.050916,109.868871 127.954546,106.192096 128.250376,102.628403 C128.438811,100.36183 128.333722,97.9580399 127.684083,95.7632173 C127.362888,94.6783705 126.853916,93.5554995 126.308378,92.5695157 C125.866281,91.7710076 123.908799,89.9203866 123.788886,89.1165882 C123.556307,87.5602415 127.973324,83.3874995 128.816339,82.3443141 C132.788953,77.4276205 136.780344,72.5320882 140.721662,67.5889431 C144.603353,62.7201931 148.506456,57.8640076 152.489612,53.0785802 C154.294237,50.9098786 163.318023,42.7148382 160.395307,39.7810237',
      id: 'Badass-Eyepatch',
      fill: '#28354B',
      fillRule: 'evenodd'
    }))));
  };

  Eyepatch.optionValue = 'Eyepatch';
  return Eyepatch;
}(React.Component);

exports.default = Eyepatch;